import {
  getUserById,
  deactivateUser as deactivateUserAPI,
} from "../../api/usersAPI";

import {
  SET_LOADING,
  SET_ERROR,
  DEACTIVATE_USER_REQUEST,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAILURE,
  SET_CURRENT_USER,
  UPDATE_CURRENT_USER,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
  LOGOUT,
} from "./actionTypes";

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setError = (errorMessage) => ({
  type: SET_ERROR,
  payload: errorMessage,
});

export const deactivateUserRequest = () => ({
  type: DEACTIVATE_USER_REQUEST,
});

export const deactivateUserSuccess = (data) => ({
  type: DEACTIVATE_USER_SUCCESS,
  payload: data,
});

export const deactivateUserFailure = (error) => ({
  type: DEACTIVATE_USER_FAILURE,
  payload: error,
});

export const fetchUserDataSuccess = (user) => ({
  type: FETCH_USER_DATA_SUCCESS,
  payload: user,
});

export const fetchUserDataFailure = (error) => ({
  type: FETCH_USER_DATA_FAILURE,
  payload: error,
});

export const setCurrentUser = (user) => ({
  type: SET_CURRENT_USER,
  payload: user,
});

export const updateCurrentUser = (user) => ({
  type: UPDATE_CURRENT_USER,
  payload: user,
});

export const deactivateUser = (userId) => async (dispatch) => {
  try {
    dispatch(deactivateUserRequest());
    // Use the deleteUser function from usersAPI.js
    const response = await deactivateUserAPI(userId);
    dispatch(deactivateUserSuccess(response.data));
  } catch (error) {
    dispatch(deactivateUserFailure(error));
  }
};

export const fetchUserData = () => async (dispatch, getState) => {
  const id = getState().loggedUser.id;
  try {
    // Use the getUserById function from usersAPI.js
    const user = await getUserById(id);

    // Dispatch the FETCH_USER_DATA_SUCCESS action with the retrieved user data
    dispatch(fetchUserDataSuccess(user));
  } catch (error) {
    // Dispatch the FETCH_USER_DATA_FAILURE action with the error message
    dispatch(fetchUserDataFailure(error.message));
  }
};

export const logout = () => (dispatch) => {
  // Clear redux-persist storage
  const { persistor } = require("../store");
  persistor.purge();
  // Reset all redux state
  dispatch({ type: LOGOUT });
};
